export default "__VITE_ASSET__DUhwwDVX__"